// Build-time feature flags. Create React App inlines REACT_APP_* variables into
// the bundle at compile time, so a disabled feature is genuinely excluded from
// the shipped JavaScript — not just hidden at runtime.
//
// Toggle at build time, e.g.:
//   REACT_APP_SHOW_COLLABORATORS=false npm run build
// or via the Docker build arg (see Dockerfile.prod). Defaults to enabled.
export const SHOW_COLLABORATORS =
    process.env.REACT_APP_SHOW_COLLABORATORS !== "false";
